import { Component, OnInit, ViewChildren, ViewChild } from '@angular/core';
import { Levels } from 'src/app/enums/custom/levels.enum';
import { DetailTotal } from 'src/app/enums/custom/detail-total.enum';
import { AnalisyType } from 'src/app/enums/custom/analisy-type.enum';
import { CustomSelect } from 'src/app/components/select/custom/custom-select/custom.select';
import { OrganizationSelect } from 'src/app/components/select/organization/organization-select/organization.select';
import { SiteSelect } from 'src/app/components/select/site/site-select/site.select';
import { ServiceCounter } from 'src/app/enums/custom/serviceCounter.enum';
import * as moment from 'moment';
import { ServiceSelect } from 'src/app/components/select/service/service-select/service.select';
import { DeviceSelect } from 'src/app/components/select/device/device-select/device.select';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { StatisticRequestBean } from 'src/app/beans/request/statistic-request.bean';
import { addIdsToArray, ChartConfiguration, CustomColumn, CustomColumnGroup, CustomTableComponent, HeaderButton } from 'src/app/components/table/custom-table/custom-table.component';
import { Statistic } from 'src/app/beans/statistic/statistic.bean';
import { PipeManager } from 'src/app/managers/pipe/pipe.manager';
import { StatisticPeriod } from 'src/app/beans/statistic/statistic.period.bean';
import { utils } from 'protractor';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { Service } from 'src/app/beans/service/service.bean';
var FileSaver = require('file-saver');

@Component({
  selector: 'statistic',
  templateUrl: './statistic.page.html',
  styleUrls: ['./statistic.page.scss']
})
export class StatisticPage implements OnInit {

  levelManager: CustomSelect
  @ViewChild('levelManager') set _levelManagerr(manager: CustomSelect)
  {
    setTimeout( () => {
      this.levelManager = manager 
    }, 0)
  } 

  analisyManager: CustomSelect
  @ViewChild('analisyManager') set _analisyManager(manager: CustomSelect)
  {
    setTimeout( () => {
      this.analisyManager = manager 
    }, 0)
  } 

  orgManager: OrganizationSelect
  @ViewChild('orgManager') set _orgManager(manager: OrganizationSelect)
  {
    setTimeout( () => {
      this.orgManager = manager 
    }, 0)
  } 

  siteManager: SiteSelect
  @ViewChild('siteManager') set _siteManager(manager: SiteSelect)
  {
    setTimeout( () => {
      this.siteManager = manager 
    }, 0)
  } 

  detailTotalManager: CustomSelect
  @ViewChild('detailTotalManager') set _detailTotalManager(manager: CustomSelect)
  {
    setTimeout( () => {
      this.detailTotalManager = manager 
    }, 0)
  } 

  serviceCounterManager: CustomSelect
  @ViewChild('serviceCounterManager') set _serviceCounterManager(manager: CustomSelect)
  {
    setTimeout( () => {
      this.serviceCounterManager = manager 
    }, 0)
  } 

  serviceManager: ServiceSelect
  @ViewChild('serviceManager') set _serviceManager(manager: ServiceSelect)
  {
    setTimeout( () => {
      this.serviceManager = manager 
    }, 0)
  } 

  all: any = {
    id              : 0 ,
    name            : "select.all"
  }


  deviceManager: DeviceSelect
  @ViewChild('deviceManager') set _deviceManager(manager: DeviceSelect)
  {
    setTimeout( () => {
      this.deviceManager = manager 
    }, 0)
  } 

  header_buttons: HeaderButton[] = [
    {
      label    : "download_excel",
      name     : "Scarica Excel",
      action   : async () => { 
        this.downloadExcel()
      } ,
      display  : () => true
    }
  ]

  @ViewChild('statisticTable') statisticTable: CustomTableComponent;

  levels = [
    {
      value : Levels.YEA,
      name  : "custom.levels.values.year",
    },
    {
      value : Levels.MON,
      name  : "custom.levels.values.month",
    },
    {
      value : Levels.WEE,
      name  : "custom.levels.values.week",
    },
    {
      value : Levels.DOW,
      name  : "custom.levels.values.day_of_week",
    },
    {
      value : Levels.DAY,
      name  : "custom.levels.values.day",
    },
    {
      value : Levels.HOD,
      name  : "custom.levels.values.hour_of_day",
    }
  ]

  analisy = [
    {
      value : AnalisyType.ORGANIZATION,
      name  : "custom.analisy.values.organization",
    },
    {
      value : AnalisyType.SITE,
      name  : "custom.analisy.values.site",
    }
  ]

  detailTotal = [
    {
      value : DetailTotal.TOTAL,
      name  : "custom.tipology.values.total",
    },
    {
      value : DetailTotal.DETAIL,
      name  : "custom.tipology.values.detail",
    }
  ]

  serviceCounter = [
    {
      value : ServiceCounter.SERVICE,
      name  : "custom.servicecounter.values.service",
    },
    {
      value : ServiceCounter.COUNTER,
      name  : "custom.servicecounter.values.counter",
    }
  ]
    
  groups: CustomColumnGroup[] = [
    {
      id: "empty",
      name : "",
      size : ( columns: CustomColumn[] ) => {
        if( !columns ) return 0 
        const resp = columns.filter( col => col.group == "empty" )
        return resp ? resp.length : 0 ;
      }
    },
    {
      id: "ticket",
      name : "Ticket",
      size : ( columns: CustomColumn[] ) => {
        if( !columns ) return 0 
        const resp = columns.filter( col => col.group == "ticket" )        
        return resp ? resp.length : 0 ;
      }
    },
    {
      id: "booking",
      name : "Booking",
      size : ( columns: CustomColumn[] ) => {   
        if( !columns ) return 0      
        const resp = columns.filter( col => col.group == "booking" )
        return resp ? resp.length : 0 ;
      }
    }
  ]

  statisticsColumns: CustomColumn []= [
    {
      isId    : true,
      label   : "id",
      name    : "id",
      display : ( val : any ) => false ,
    },
    {
      label : "periodo",
      name  : "tables.statistics.labels.periodo",
      group : "empty"
    },
    {
      display : () =>  this.getGenericName() != null,
      label   : "genericName",
      name    : this.getGenericName(),
      group : "ticket"
    },
    {
      label : "gemessi",
      name  : "tables.statistics.labels.gemessi",
      group : "ticket"
    },
    {
      label : "gserviti",
      name  : "tables.statistics.labels.gserviti",
      group : "ticket"
    },
    {
      label : "gabbandoni",
      name  : "tables.statistics.labels.gabbandoni",
      group : "ticket"
    },
    {
      label : "gterminati",
      name  : "tables.statistics.labels.gterminati",
      group : "ticket"
    },
    {
      label : "gsecAttesa",
      name  : "tables.statistics.labels.gsecAttesa",
      pipe  : (time: any ) => this._pipe.tables().time_pipe_seconds_to_time( time, "-"),
      group : "ticket"
    },
    {
      label : "gsecServizio",
      name  : "tables.statistics.labels.gsecServizio",
      pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-"),
      group : "ticket"
    },
    {
      label : "gmaxUtentiAttesa",
      name  : "tables.statistics.labels.gmaxUtentiAttesa",
      group : "ticket"
    },
    {
      label : "gmaxAttesa",
      name  : "tables.statistics.labels.gmaxAttesa",
      pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-"),
      group : "ticket"
    },
    {
      label : "gcntUserLim1",
      name  : "tables.statistics.labels.gcntUserLim1",
      group : "ticket"
    },
    {
      label : "gcntUserLim2",
      name  : "tables.statistics.labels.gcntUserLim2",
      group : "ticket"
    },
    {
      label : "gcntUserLim2Perc",
      name  : "tables.statistics.labels.gcntUserLim2Perc",
      group : "ticket",
      pipe  : (val: any) => val == 0 ? "-" : this._utils.number().round(val) + "%",
    },
    {
      label : "bemessi",
      name  : "tables.statistics.labels.bemessi",
      group : "booking"
    },
    {
      label : "bserviti",
      name  : "tables.statistics.labels.bserviti",
      group : "booking"
    },
    {
      label : "babbandoni",
      name  : "tables.statistics.labels.babbandoni",
      group : "booking"
    },
    {
      label : "bterminati",
      name  : "tables.statistics.labels.bterminati",
      group : "booking"
    },
    {
      label : "bsecAttesa",
      name  : "tables.statistics.labels.bsecAttesa",
      pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-"),
      group : "booking"
    },
    {
      label : "bsecServizio",
      name  : "tables.statistics.labels.bsecServizio",
      pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-"),
      group : "booking"
    },
    {
      label : "bmaxAttesa",
      name  : "tables.statistics.labels.bmaxAttesa",
      pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-"),
      group : "booking"
    },
    {
      label : "bcntUserLim1",
      name  : "tables.statistics.labels.bcntUserLim1",
      group : "booking"
    },
    {
      label : "bcntUserLim2",
      name  : "tables.statistics.labels.bcntUserLim2",
      group : "booking"
    },
    {
      label : "bcntUserLim2Perc",
      name  : "tables.statistics.labels.bcntUserLim2Perc",
      group : "booking",
      pipe  : (val: any) => val == 0 ? "-" : this._utils.number().round(val) + "%",

    }
  ]

  chartsConf: ChartConfiguration[] = [
    {
      id: "ch_1",
      labels    :   {
        name: "periodo",
        isColumn: true
      },
      columns   :   [
        {
          label : "gemessi",
          name  : "tables.statistics.labels.gemessi",
        },
        {
          label : "gserviti",
          name  : "tables.statistics.labels.gserviti",
        },
        {
          label : "gabbandoni",
          name  : "tables.statistics.labels.gabbandoni",
        },
        {
          label : "gterminati",
          name  : "tables.statistics.labels.gterminati",
        },
        {
          label : "bemessi",
          name  : "tables.statistics.labels.bemessi",
        },
        {
          label : "bserviti",
          name  : "tables.statistics.labels.bserviti",
        },
        {
          label : "babbandoni",
          name  : "tables.statistics.labels.babbandoni",
        },
        {
          label : "bterminati",
          name  : "tables.statistics.labels.bterminati",
        },
      ] ,
      type      : 'bar',
    },
    {
      id: "ch_2",
      labels:   
      {
        name: "periodo",
        isColumn: true
      },
      columns:   
      [
        {
          label : "gsecAttesa",
          name  : "tables.statistics.labels.gsecAttesa",
          pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-")
        },
        {
          label : "gsecServizio",
          name  : "tables.statistics.labels.gsecServizio",
          pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-")
        },
        {
          label : "gmaxUtentiAttesa",
          name  : "tables.statistics.labels.gmaxUtentiAttesa",
        },
        {
          label : "gmaxAttesa",
          name  : "tables.statistics.labels.gmaxAttesa",
          pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-")
        },
        {
          label : "bsecAttesa",
          name  : "tables.statistics.labels.bsecAttesa",
          pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-")
        },
        {
          label : "bsecServizio",
          name  : "tables.statistics.labels.bsecServizio",
          pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-")
        },
        {
          label : "bmaxAttesa",
          name  : "tables.statistics.labels.bmaxAttesa",
          pipe  : (time: any) => this._pipe.tables().time_pipe_seconds_to_time(time, "-")
        }
      ],
      type: 'bar',
      scales: {
        yAxes: [{
            
            ticks: {
                stepSize: 60 * 30 ,
                // Include a dollar sign in the ticks
                callback: ( value: any ) => {
                  try{
                    return this._utils.time().numberToTime( value )
                  }catch(e){
                    return value
                  }
                }
            }
        }]
      },
      tooltips: {
        callbacks: {
          label: ( item: any ) => {
            try{
              return this._utils.time().numberToTime( item.value )   
            }catch(e){
              return item.value
            }
          }
        }
      }
    },
  ]

  dateFrom: moment.Moment = moment().subtract(1, 'days')
  dateTo  : moment.Moment = moment().subtract(1, 'days')
  maxDate : moment.Moment = moment().subtract(1, 'days')

  statistics: Statistic[] = []

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = 

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _pipe   : PipeManager   ,
    private _utils  : UtilsManager
  ) {}

  ngOnInit(): void {}

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = 

  showOrganizations(){
    if (!this.analisyManager) return false
    const selected = this.analisyManager.getSelectedValue()
    return selected.value == AnalisyType.ORGANIZATION
  }

  showSites(){
    if (!this.analisyManager) return false
    const selected = this.analisyManager.getSelectedValue()
    return selected.value == AnalisyType.SITE
  }

  showDetailTotal(){
    const showSite = this.showSites()
    return showSite
  }

  showServiceCounter(){
    if (!this.showDetailTotal()) return false
    const selected = this.detailTotalManager.getSelectedValue()
    return selected.value == DetailTotal.DETAIL
  }

  showService(){
    if (!this.showServiceCounter()) return false
    const selected = this.serviceCounterManager.getSelectedValue()
    return selected.value == ServiceCounter.SERVICE
  }

  showDevice(){
    if (!this.showServiceCounter()) return false
    const selected = this.serviceCounterManager.getSelectedValue()
    return selected.value == ServiceCounter.COUNTER
  }

  formatStatisticObj() 
  {
    const period = this.levelManager.getSelectedValue().value

    let level = this.analisyManager.getSelectedValue().value

    const sc = this.showServiceCounter() ? this.serviceCounterManager.getSelectedValue().value : null

    if(level == "SI" && sc != null) 
    {    
      if (sc == ServiceCounter.COUNTER) level = "DE"
      if (sc == ServiceCounter.SERVICE) level = "SE"
    }

    const levelid = this.getLevelId ( level )
    

    const scid = sc ? ( sc == ServiceCounter.COUNTER ? this.getLevelId ( "DE" ) : this.getLevelId ( "SE" ) ) : null
    
    const dt = this.showDetailTotal()  ? this.detailTotalManager.getSelectedValue().value : null

    const dateFrom = this.dateFrom .format("yyyy-MM-DD");
    const dateTo   = this.dateTo   .format("yyyy-MM-DD");


    const data: StatisticRequestBean = 
    {
      period    : period  ,
      level     : level   ,
      levelid   : levelid ,
      sc        : sc      ,
      scid      : scid    ,
      dt        : dt      ,
      datefrom  : dateFrom,
      dateto    : dateTo  
    }

    return data
  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = 

  async getStatistics() 
  {
    const data = this.formatStatisticObj()

    const user = this._session.user().get()

    if (!User.isKind( user )) return // TODO handle user incorrect 

    this._loader.start()

    this.statisticTable.reloadData()

    let response = await this._handler.statistic().get(( user as User ).token, data )

    this._loader.stop()
    
    this.statisticTable.dataLoaded()

    if(!response) return 

    let statistics: StatisticPeriod[] = response as StatisticPeriod[]

    statistics = this.formatStatistic(statistics)

    this.statistics = addIdsToArray(statistics) 
        
    return response;
  }

  getSiteId(){
    return this.siteManager.getSelectedValue().id
  }

  getLevelId(level: string) 
  {
    switch (level) {
      case "OR": return this.orgManager     .getSelectedValue().id
      case "SI": return this.siteManager    .getSelectedValue().id
      case "SE": return this.serviceManager .getSelectedValue().id
      case "DE": return this.deviceManager  .getSelectedValue().id
    }
  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = 

  formatStatistic(raws: StatisticPeriod[])
  {
    raws.forEach
    (
      (raw) => {

        raw.gsecAttesa = raw.gsecAttesa / raw.gserviti
        raw.bsecAttesa = raw.bsecAttesa / raw.bserviti

        raw.gsecServizio = raw.gsecServizio / raw.gserviti
        raw.bsecServizio = raw.bsecServizio / raw.bserviti

        if ( raw.gemessi - raw.gabbandoni == 0 ) 
          raw.gcntUserLim2Perc = 0
        else
          raw.gcntUserLim2Perc = 100 - ( raw.gcntUserLim2 / ( raw.gemessi - raw.gabbandoni) ) 

        if ( raw.bemessi - raw.babbandoni == 0 ) 
          raw.gcntUserLim2Perc = 0
        else
          raw.bcntUserLim2Perc = 100 - ( raw.bcntUserLim2 / ( raw.bemessi - raw.babbandoni) )


        // raw.gmediaattesa  = this.getMedia(raw.gsecAttesa  ,raw.gserviti   )
        // raw.gmediaserviti = this.getMedia(raw.gsecServizio,raw.gterminati )
        // raw.bmediaattesa  = this.getMedia(raw.bsecAttesa  ,raw.bserviti   )
        // raw.bmediaserviti = this.getMedia(raw.bsecServizio,raw.bterminati )
      }
    )    
    return raws
  }

  getGenericName(): string
  {

    if(!this.showDetailTotal()) return null

    if(this.showServiceCounter()) 
    {
      if(this.serviceCounterManager.getSelectedValue().value == ServiceCounter.SERVICE)
      return "tables.statistics.labels.genericNameServizi"

      if(this.serviceCounterManager.getSelectedValue().value == ServiceCounter.COUNTER)
      return "tables.statistics.labels.genericNameSportelli"
    }
      
    return null
  }

  getMedia (time: any, served: any) {

    if (!time || isNaN(Number(time))) return 0

    if (!served || served == "0" || isNaN(Number(served))) return 0

    return Math.abs(Number((Number(time) / Number(served)).toPrecision(1)));
  }

  async downloadExcel( ){
    const data = this.formatStatisticObj()
    const user  = this._session.user().get()

    if (!User.isKind( user )) return // TODO handle user incorrect 
    this._loader.start()
    let response = await this._handler.statistic().excel(( user as User ).token, data )
    this._loader.stop()
    
    if ( !response ) return 
    try {
      var blob = new Blob( [response], { type: "application/vnd.ms-excel" } );
      FileSaver.saveAs( blob, `${this.generateFileName(data)}.xls` );
    }catch (error){
      console.log(error);
    }
  }

  generateFileName( data: StatisticRequestBean){
    switch( data.level ){
      case "OR": return `stat_${this.formatName(this.orgManager     .currentValue.name)}`
      case "SI": return `stat_${this.formatName(this.siteManager    .currentValue.name)}`
      case "SE": return `stat_${this.formatName(this.serviceManager .currentValue.name)}`
      case "DE": return `stat_${this.formatName(this.deviceManager  .currentValue.name)}`
    }
  }

  formatName( name: string)
  {
    name = name .split('.').join('_')
                .split('-').join(' ')
                .split(' ').join('_')
    name = name.replace(/ +/g, ' ')
    return name.replace(/_+/g,'_')
  }

}
